<!-- eslint-disable -->
<template>
  <div
    data-elementor-type="wp-page"
    data-elementor-id="2166"
    class="elementor elementor-2166"
    data-elementor-settings="[]"
    style="background-color: white; padding: 0px ; z-index:99;"
  >
    <div class="elementor-section-wrap">
      <section
        class="has_eae_slider elementor-section elementor-top-section elementor-element elementor-element-3eb5b41 elementor-section-height-full elementor-section-items-top elementor-section-boxed elementor-section-height-default"
        data-particle_enable="false"
        data-particle-mobile-disabled="false"
        data-id="3eb5b41"
        data-element_type="section"
    style="z-index:99;"

        
      >
        <div class="elementor-container elementor-column-gap-no">
          <div
            class="has_eae_slider elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-17f0ce6"
            data-id="17f0ce6"
            data-element_type="column"
            data-settings='{"background_background":"classic"}'

          >
            <div
              class="elementor-widget-wrap elementor-element-populated"
              style="padding: 20px"
            >
              <div
                class="elementor-element elementor-element-13ab662 elementor-align-left elementor-widget__width-auto elementor-widget elementor-widget-button"
                data-id="13ab662"
                data-element_type="widget"
                data-widget_type="button.default"
              >
                <!--div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <a
                      href="#"
                      class="elementor-button-link elementor-button elementor-size-sm"
                      role="button"
                    >
                      <span class="elementor-button-content-wrapper">
                        <span class="elementor-button-text">{{lang.qrPrint.screenshot}}</span>
                      </span>
                    </a>
                  </div>
                </div-->
              </div>
              <div
                class="elementor-element elementor-element-efcf9a5 elementor-align-left elementor-widget__width-auto elementor-widget elementor-widget-button"
                data-id="efcf9a5"
                data-element_type="widget"
                data-widget_type="button.default"
                @click.prevent="saveAsPdf"
                style="cursor: pointer;"
              >
                <div class="elementor-widget-container">
                  <div class="elementor-button-wrapper">
                    <a
                      href="javascript:void(0)"
                      class="elementor-button-link elementor-button elementor-size-sm"
                      role="button"
                      :style="isGeneratingPdf ? 'pointer-events: none; opacity: 0.7;' : ''"
                    >
                      <span class="elementor-button-content-wrapper">
                        <span class="elementor-button-text">
                          <i :class="isGeneratingPdf ? 'fa fa-spinner fa-spin' : 'fa fa-file-pdf-o'" style="margin-right: 6px;"></i>
                          {{ isGeneratingPdf ? (isArabic ? 'جاري التحميل...' : (isFrench ? 'Téléchargement...' : 'Downloading PDF...')) : (lang.qrPrint && lang.qrPrint.saveAsPdf ? lang.qrPrint.saveAsPdf : ($t('qrPrint.saveAsPdf') || 'Save as PDF')) }}
                        </span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-c1f6a1c elementor-widget elementor-widget-image"
                data-id="c1f6a1c"
                data-element_type="widget"
                data-widget_type="image.default"
              >
                <div class="elementor-widget-container" style="text-align: center;">
                  <div
                    style="background-color: #1a1a1a; padding: 16px 36px; border-radius: 10px; display: inline-block; box-shadow: 0 2px 10px rgba(0,0,0,0.12);"
                  >
                    <img
                      id="receiptHotelLogoImg"
                      width="518"
                      height="268"
                      :src="hotelLogo"
                      crossorigin="anonymous"
                      class="attachment-full size-full"
                      alt="Hotel Logo"
                      style="max-width: 280px; height: 95px; object-fit: contain; display: block; margin: 0 auto;"
                    />
                  </div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-27af712 elementor-widget elementor-widget-bdt-qrcode"
                data-id="27af712"
                data-element_type="widget"
                data-widget_type="bdt-qrcode.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="bdt-qrcode"
                    data-settings='{"render":"canvas","ecLevel":"H","minVersion":4,"fill":"#333333","text":"#content","size":100,"mSize":11,"mPosX":50,"mPosY":50,"background":"transparent"}'
                  ></div>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-dddb170 elementor-widget elementor-widget-tp-table"
                data-id="dddb170"
                data-element_type="widget"
                data-widget_type="tp-table.default"
              >
                <div class="elementor-widget-container">
                  <div itemscope class="plus-table-wrapper">
                    <table
                      id="plus-table-id-dddb170"
                      class="plus-table plus-text-break plus-column-rules"
                      data-sort-table="no"
                      data-show-entry="no"
                      data-searchable="no"
                    >
                      <tbody>
                        <!-- ROWS -->
                        <tr data-entry="1" class="plus-table-row">
                          <td
                            id="tooltip61ca7f1ba189f"
                            class="plus-table-col elementor-repeater-item-07eeede"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner"
                                >{{lang.qrPrint.mr}}. {{ orderData.guest.first_name }} , {{ orderData.guest.last_name }}</span
                              >
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba18b9"
                            class="plus-table-col elementor-repeater-item-afa0769"
                          >
                            <span class="plus-table__text"> </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba18c6"
                            class="plus-table-col elementor-repeater-item-ef225e6"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{lang.qrPrint.room}}#</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba18d3"
                            class="plus-table-col elementor-repeater-item-8fef659"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{orderData.guest.more_data.room_number}}</span>
                            </span>
                          </td>
                        </tr>
                        <tr data-entry="2" class="plus-table-row">
                          <td
                            id="tooltip61ca7f1ba18e9"
                            class="plus-table-col elementor-repeater-item-ae1ddfe"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{lang.qrPrint.numberOfCompanions}}</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba18f6"
                            class="plus-table-col elementor-repeater-item-05dcdbc"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{this.guestData.companions}}</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba19c4"
                            class="plus-table-col elementor-repeater-item-3259690"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{lang.qrPrint.day}}</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba19cf"
                            class="plus-table-col elementor-repeater-item-2f72130"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{orderDay}}</span>
                            </span>
                          </td> 
                           
                        </tr>
                        <tr data-entry="3" class="plus-table-row">
                          <td
                            id="tooltip61ca7f1ba1927"
                            class="plus-table-col elementor-repeater-item-348eaa7"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{lang.qrPrint.date}}:</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba1933"
                            class="plus-table-col elementor-repeater-item-2613432"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner"
                                >{{orderData.booking_details.date}}</span
                              >
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba193e"
                            class="plus-table-col elementor-repeater-item-056c82b"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{lang.qrPrint.time}}</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba194b"
                            class="plus-table-col elementor-repeater-item-dd1d052"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{ orderData.booking_details.time.time }}</span>
                            </span>
                          </td>
                        </tr>
                        <tr data-entry="4" class="plus-table-row">
                          <td
                            id="tooltip61ca7f1ba1927"
                            class="plus-table-col elementor-repeater-item-348eaa7"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{lang.qrPrint.checkin_date}}Checkin Date:</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba1933"
                            class="plus-table-col elementor-repeater-item-2613432"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner"
                                >{{this.guestData.guestArrivalData}}</span
                              >
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba193e"
                            class="plus-table-col elementor-repeater-item-056c82b"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{lang.qrPrint.checkin_date}}Checkout Date:</span>
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba194b"
                            class="plus-table-col elementor-repeater-item-dd1d052"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{ this.guestData.guestDepartureDate }}</span>
                            </span>
                          </td>
                        </tr>
                        <tr data-entry="5" class="plus-table-row">
                          <td
                            id="tooltip61ca7f1ba195d"
                            class="plus-table-col elementor-repeater-item-a787b74"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner"
                                >{{lang.qrPrint.restraunt}}:</span
                              >
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba1979"
                            class="plus-table-col elementor-repeater-item-92da8fd"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner"
                                >{{ orderData.restaurant.title }}</span
                              >
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba1986"
                            class="plus-table-col elementor-repeater-item-a691812"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner"
                                >{{lang.qrPrint.bookingNo}}.</span
                              >
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba1993"
                            class="plus-table-col elementor-repeater-item-5ca2f0d"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{ orderData.booking_details.book_number}}</span>
                            </span>
                          </td>
                        </tr>
                        <tr data-entry="6" class="plus-table-row">
                          <td
                            id="tooltip61ca7f1ba19aa"
                            class="plus-table-col elementor-repeater-item-2e67d6d"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner"
                                >{{lang.qrPrint.reservation}}#</span
                              >
                            </span>
                          </td>
                          <td
                            id="tooltip61ca7f1ba19b7"
                            class="plus-table-col elementor-repeater-item-9ad4875"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{orderData.guest.more_data.reservation}}</span>
                            </span>
                          </td>
                          <td
                            class="plus-table-col elementor-repeater-item-a691812"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{ allergyLabel }}:</span>
                            </span>
                          </td>
                          <td
                            class="plus-table-col elementor-repeater-item-5ca2f0d"
                          >
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner" :style="bookingAllergies ? 'color: #dc3545; font-weight: bold;' : ''">
                                {{ bookingAllergies || noneAllergyLabel }}
                              </span>
                            </span>
                          </td>
                        </tr>
                        <tr data-entry="7" class="plus-table-row">
                          <td class="plus-table-col elementor-repeater-item-2e67d6d">
                            <span class="plus-table__text">
                              <span class="plus-table__text-inner">{{ bookingTypeTitleLabel }}:</span>
                            </span>
                          </td>
                          <td class="plus-table-col elementor-repeater-item-9ad4875" colspan="3">
                            <span class="plus-table__text">
                              <span
                                class="plus-table__text-inner"
                                :style="isPaidBooking ? 'background-color: #dc3545; color: #ffffff; padding: 3px 10px; border-radius: 4px; font-weight: bold; display: inline-block;' : 'background-color: #28a745; color: #ffffff; padding: 3px 10px; border-radius: 4px; font-weight: bold; display: inline-block;'"
                              >
                                {{ bookingTypeBadgeLabel }}
                              </span>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="elementor-widget-container" v-if="orderData.items && orderData.items.length">
                            <div itemscope class="plus-table-wrapper">
                              <table
                                id="plus-table-id-ff28744"
                                class="plus-table plus-text-break plus-column-rules"
                                data-sort-table="no"
                                data-show-entry="no"
                                data-searchable="no"
                              >
                              
                                <thead>
                                <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="5"
                                      style="text-align:center;background-color: #f5f5f7;"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.qrPrint.orderItems}}</span
                                        >
                                      </span>
                                    </td>
                                    
                                  </tr>
                                  <tr class="plus-table-row">
                                    
                              
                                    <th
                                      id="tooltip61ca7f61926ae"
                                      data-sort="1"
                                      class="sort-this elementor-repeater-item-9e20a5c plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner"
                                            >{{lang.checkOut.items}}</span
                                          >
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926ba"
                                      data-sort="3"
                                      class="sort-this elementor-repeater-item-8c532cc plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner">
                                          </span>
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926c5"
                                      data-sort="4"
                                      class="sort-this elementor-repeater-item-a657855 plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner"
                                            >{{lang.checkOut.qty}}</span
                                          >
                                        </span>
                                      </span>
                                    </th>
                                    <th
                                      id="tooltip61ca7f61926d1"
                                      data-sort="5"
                                      class="sort-this elementor-repeater-item-46795f3 plus-table-col"
                                      data-local="true"
                                      scope="col"
                                    >
                                      <span class="sort-style">
                                        <span class="plus-table__text">
                                          <span class="plus-table__text-inner"
                                            >{{lang.checkOut.subTotal}}</span
                                          >
                                        </span>
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <!-- ROWS -->

                                  <tr
                                    v-for="cartItem in orderData.items"
                                    :key="cartItem.id"
                                    data-entry="1"
                                    class="plus-table-row"
                                  >
                                    
              
                                    <td
                                      id="tooltip61ca7f6192df0"
                                      class="plus-table-col elementor-repeater-item-4a20cff"
                                      data-title="Item"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cartItem.name }}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e03"
                                      class="plus-table-col elementor-repeater-item-23993e6"
                                      data-title="Price"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner">
                                        </span>
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e16"
                                      class="plus-table-col elementor-repeater-item-21b7c99"
                                      data-title="Qty"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cartItem.quantity }}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e34"
                                      class="plus-table-col elementor-repeater-item-9a4799b"
                                      data-title="Sub Total"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ cartItem.price * cartItem.quantity  }} {{currency}}</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
                                  <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="5"
                                      style="text-align:center;background-color: #f5f5f7;"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.qrPrint.orderSummary}}</span
                                        >
                                      </span>
                                    </td>
                                    
                                  </tr>
                                  <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="1"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.checkOut.subTotal}}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e69"
                                      class="plus-table-col elementor-repeater-item-1eb938f"
                                      colspan="3"

                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          > {{ orderData.subtotal }} {{currency}}</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
								                  <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="1"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.checkOut.tax}}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e69"
                                      class="plus-table-col elementor-repeater-item-1eb938f"
                                      colspan="3"

                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ orderData.tax   }}%</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
								                  <tr data-entry="2" class="plus-table-row">
                                    <td
                                      id="tooltip61ca7f6192e5b"
                                      class="plus-table-col elementor-repeater-item-18e4b68"
                                      colspan="1"
                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{lang.checkOut.grandTotal}}</span
                                        >
                                      </span>
                                    </td>
                                    <td
                                      id="tooltip61ca7f6192e69"
                                      class="plus-table-col elementor-repeater-item-1eb938f"
                                      colspan="3"

                                    >
                                      <span class="plus-table__text">
                                        <span class="plus-table__text-inner"
                                          >{{ orderData.total_price }} {{currency}}</span
                                        >
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div v-if="!orderData.items || !orderData.items.length" class="text-center my-3 p-3" style="text-align: center; background: #f8f9fa; border-radius: 8px; margin: 15px 0;">
                            <h4 style="margin: 0; color: #495057; font-weight: bold;">
                              {{ $t('qrPrint.seatOnlyReservation') || 'Seat Reservation Only' }}
                            </h4>
                          </div>
                  </div>
                </div>
              </div>
              <div
                v-if="orderData.items && orderData.items.length"
                class="elementor-element elementor-element-1f15da0 elementor-widget elementor-widget-heading"
                data-id="1f15da0"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">
                    Total:
                  </h2>
                </div>
              </div>
              <div
                v-if="orderData.items && orderData.items.length"
                class="elementor-element elementor-element-d6f98ec elementor-widget elementor-widget-heading"
                data-id="d6f98ec"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default" :style="isPaidBooking ? 'color: #dc3545;' : ''">
                    {{ isPaidBooking ? bookingTypeBadgeLabel : 'Complimentary' }}
                  </h2>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-f99d7f4 elementor-widget elementor-widget-text-editor"
                data-id="f99d7f4"
                data-element_type="widget"
                data-widget_type="text-editor.default"
              >
                <div class="elementor-widget-container">
                  <div v-if="orderData.restaurant && orderData.restaurant.confirmation_terms" style="white-space: pre-line; line-height: 1.6; font-size: 1rem; color: #333; text-align: start; padding: 12px; background: #fdfdfd; border-left: 4px solid #d4af37; margin-top: 15px; border-radius: 4px;">
                    {{ orderData.restaurant.confirmation_terms }}
                  </div>
                  <p v-else>
                    • In all restaurants dress code is “smart casual elegant”.
                    Dear gentlemen please avoid short pants in general and<br />please
                    wear trousers.<br />• Минимальный дресс код: повседневная
                    одежда и обувь, приветствуется элегантный повседневный стиль
                    в<br />одежде (для мужчин длинные брюки вечером).<br />يرجى
                    ارتداء الملابس المناسبة داخل جميع المطاعم وعدم ارتداء ملابس
                    البحر او حافى القدمين لا يسمح بارتداء الشورت او •<br />.
                    الشبشب او الترينجات الرياضيه<br />• Es gilt in allen
                    Restaurants die Kleiderordnung “schick, lässig, elegant”.Der
                    Mann sollte eine lange Hose tragen<br />• Dans tous les
                    restaurants, le code vestimentaire est décontracté et
                    élégant.<br />• Vi chiediamo di indossare in tutti i
                    ristoranti un abbigliamento appropriato, “smart casual
                    elegant”.
                  </p>
                </div>
              </div>
              <div
                class="elementor-element elementor-element-d9db391 elementor-widget elementor-widget-heading"
                data-id="d9db391"
                data-element_type="widget"
                data-widget_type="heading.default"
              >
                <div class="elementor-widget-container">
                  <h2 class="elementor-heading-title elementor-size-default">
                    Thank You
                  </h2>
                </div>
				<div id="thermalPrintContent" style="display:none;text-align:center;">
					{{lang.qrPrint ? lang.qrPrint.mr : 'Mr'}}. {{ orderData.guest.first_name }} , {{ orderData.guest.last_name }}
          <br>{{ lang.profile ? lang.profile.arrivalDate : 'Arrival Date' }}: {{ guestData.guestArrivalData }}
          <br>{{ lang.profile ? lang.profile.departureDate : 'Departure Date' }}: {{  guestData.guestDepartureDate}}
					<br>{{lang.qrPrint ? lang.qrPrint.room : 'Room'}}#{{orderData.guest.more_data.room_number}}
					<br>{{lang.qrPrint ? lang.qrPrint.numberOfCompanions : 'Guests'}}:{{this.guestData.companions}}
					<br>{{lang.qrPrint ? lang.qrPrint.day : 'Day'}}:{{orderDay}} ({{lang.qrPrint ? lang.qrPrint.date : 'Date'}}:{{orderData.booking_details.date}} - {{ orderData.booking_details.time.time }})
					<br>{{lang.qrPrint ? lang.qrPrint.restraunt : 'Restaurant'}}:{{ orderData.restaurant.title }}
					<br>{{ allergyLabel }}: {{ bookingAllergies || noneAllergyLabel }}
					<br><strong>{{ bookingTypeTitleLabel }}: {{ bookingTypeBadgeLabel }}</strong>
					<template v-if="orderData.items && orderData.items.length">
						<hr>{{lang.qrPrint ? lang.qrPrint.orderItems : 'Order Items'}}
						<table>
							<tr
								v-for="cartItem in orderData.items"
								:key="cartItem.id"
								data-entry="1"
								class="plus-table-row"
							>
							<td>{{ cartItem.name }}</td>
							<td>{{ cartItem.quantity }}</td>
							<td>{{ cartItem.price * cartItem.quantity  }} {{currency}}</td>
							</tr>
						</table>
						<hr>{{lang.qrPrint ? lang.qrPrint.orderSummary : 'Order Summary'}}
						<br>{{lang.checkOut ? lang.checkOut.subTotal : 'Sub Total'}}:{{ orderData.subtotal }} {{currency}}
						<br>{{lang.checkOut ? lang.checkOut.tax : 'Tax'}}:{{ orderData.tax   }}%
						<br>{{lang.checkOut ? lang.checkOut.grandTotal : 'Grand Total'}}:{{ orderData.total_price }} {{currency}}
					</template>
					<template v-else>
						<hr>
						<div style="font-weight: bold; margin: 8px 0;">--- {{ $t('qrPrint.seatOnlyReservation') || 'Seat Reservation Only' }} ---</div>
					</template>
					<div v-if="orderData.restaurant && orderData.restaurant.confirmation_terms" style="font-size: 11px; margin-top: 8px; border-top: 1px dashed #ccc; padding-top: 6px; white-space: pre-line;">
						{{ orderData.restaurant.confirmation_terms }}
					</div>
				</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>

</template>

<script>
import { jsPDF } from 'jspdf';

export default {
  name: "QrPrint",
  data(){
    if(localStorage.getItem("localization")=="ar") {
      document.querySelector('html').classList.add('is-rtl');
    }

    return{
      hotelLogo: localStorage.getItem("hotelLogo") || "",
      guestData:[],
      orderData:'',
      orderDay:'',
      lang:"",
      currency:"",
      isGeneratingPdf: false
    }
  },
  computed: {
    currentLocale() {
      return localStorage.getItem("localization") || (this.$i18n && this.$i18n.locale) || 'en';
    },
    isArabic() {
      return this.currentLocale === 'ar';
    },
    isFrench() {
      return this.currentLocale === 'fr';
    },
    bookingAllergies() {
      const fromOrder =
        (this.orderData && this.orderData.allergies) ||
        (this.orderData && this.orderData.booking_details && this.orderData.booking_details.allergies) ||
        "";
      if (fromOrder && fromOrder !== "empty") {
        return fromOrder;
      }
      return localStorage.getItem("currentBookingAllergies") || "";
    },
    allergyLabel() {
      const map = {
        en: "Allergies",
        fr: "Allergies",
        it: "Allergie",
        de: "Allergien",
        ru: "Аллергия",
        ar: "الحساسية"
      };
      return (this.lang && this.lang.qrPrint && this.lang.qrPrint.allergies) || map[this.currentLocale] || "Allergies";
    },
    noneAllergyLabel() {
      const map = {
        en: "None",
        fr: "Aucune",
        it: "Nessuna",
        de: "Keine",
        ru: "Нет",
        ar: "لا يوجد"
      };
      return map[this.currentLocale] || "None";
    },
    isPaidBooking() {
      if (!this.orderData) return false;
      return Boolean(
        this.orderData.is_paid ||
        (this.orderData.booking_details && this.orderData.booking_details.is_paid) ||
        Number(this.orderData.total_price || 0) > 0
      );
    },
    bookingTypeTitleLabel() {
      const map = {
        en: "Booking Type",
        fr: "Type de réservation",
        it: "Tipo di prenotazione",
        de: "Buchungstyp",
        ru: "Тип бронирования",
        ar: "نوع الحجز"
      };
      return map[this.currentLocale] || "Booking Type";
    },
    bookingTypeBadgeLabel() {
      if (this.isPaidBooking) {
        const paidMap = {
          en: "Paid (With Fees)",
          fr: "Payant (Avec frais)",
          it: "A pagamento (Con supplemento)",
          de: "Kostenpflichtig (Mit Gebühren)",
          ru: "Платно (С доплатой)",
          ar: "مدفوع (برسوم إضافية)"
        };
        return paidMap[this.currentLocale] || "Paid (With Fees)";
      }
      const freeMap = {
        en: "Free (Package)",
        fr: "Gratuit (Forfait)",
        it: "Gratuito (Pacchetto)",
        de: "Kostenlos (Paket)",
        ru: "Бесплатно (Пакет)",
        ar: "مجاني (ضمن الباقة)"
      };
      return freeMap[this.currentLocale] || "Free (Package)";
    }
  },
  created(){
    this.ensureHotelLogo();
    this.getGuestInfo();
    this.setLang();
    this.currency = localStorage.getItem("currency") || '';
  },
  mounted(){
    const slider = document.querySelector('.slider-container');
    if (slider) {
      slider.style.display = '';
    }
  },
  beforeDestroy(){
    const slider = document.querySelector('.slider-container');
    if (slider) {
      slider.style.display = '';
    }
    const htmlEl = document.querySelector('html');
    if (htmlEl && localStorage.getItem("localization") !== "ar") {
      htmlEl.classList.remove('is-rtl');
    }
  },
  methods:{
    ensureHotelLogo() {
      if (this.hotelLogo) return;
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "api/hotel-data?api_key=" +
            process.env.VUE_APP_API_KEY +
            "&lang=" +
            (process.env.VUE_APP_LANG || "en") +
            "&hotel_id=1"
        )
        .then((res) => {
          if (res.data && res.data.data && res.data.data.logo) {
            const logoUrl = process.env.VUE_APP_API_BASE_URL + res.data.data.logo;
            this.hotelLogo = logoUrl;
            localStorage.setItem("hotelLogo", logoUrl);
          }
        })
        .catch((err) => console.log("Error fetching hotel logo:", err));
    },
    loadLogoForCanvas(src) {
      return new Promise((resolve) => {
        if (!src) {
          resolve(null);
          return;
        }
        const img = new Image();
        img.crossOrigin = "anonymous";
        const timer = setTimeout(() => resolve(null), 3500);
        img.onload = () => {
          clearTimeout(timer);
          resolve(img);
        };
        img.onerror = () => {
          clearTimeout(timer);
          const domImg = document.getElementById("receiptHotelLogoImg");
          if (domImg && domImg.complete && domImg.naturalWidth > 0) {
            resolve(domImg);
          } else {
            resolve(null);
          }
        };
        img.src = src + (src.indexOf("?") === -1 ? "?t=" : "&t=") + Date.now();
      });
    },
    wrapCanvasText(ctx, text, maxWidth) {
      if (!text) return [];
      const paragraphs = String(text).split(/\r?\n/);
      const lines = [];
      paragraphs.forEach((para) => {
        const trimmed = para.trim();
        if (!trimmed) {
          lines.push("");
          return;
        }
        const words = trimmed.split(/\s+/);
        let currentLine = words[0] || "";
        for (let i = 1; i < words.length; i++) {
          const word = words[i];
          const testLine = currentLine + " " + word;
          if (ctx.measureText(testLine).width <= maxWidth) {
            currentLine = testLine;
          } else {
            lines.push(currentLine);
            currentLine = word;
          }
        }
        lines.push(currentLine);
      });
      return lines;
    },
    async saveAsPdf() {
      if (this.isGeneratingPdf) return;
      this.isGeneratingPdf = true;

      try {
        const loc = this.currentLocale;
        const labels = {
          en: {
            title: "Reservation Confirmation & Receipt",
            bookingRef: "Booking Reference",
            qrHint: "Please present this QR code upon arrival at the restaurant",
            detailsTitle: "Guest & Reservation Details",
            guestName: "Guest Name",
            room: "Room #",
            restaurant: "Restaurant",
            guests: "Guests",
            dateTime: "Date & Time",
            hotelRes: "Reservation #",
            arrival: "Arrival Date",
            departure: "Departure Date",
            allergies: "Allergies",
            noneAllergies: "None",
            orderItems: "Ordered Items",
            item: "Item",
            qty: "Qty",
            price: "Price",
            total: "Total",
            subtotal: "Subtotal",
            tax: "Tax",
            grandTotal: "Grand Total",
            complimentary: "Complimentary",
            seatOnly: "Seat Reservation Only",
            termsTitle: "Terms & Dress Code",
            thankYou: "Thank you for choosing us! We look forward to welcoming you."
          },
          fr: {
            title: "Confirmation et reçu de réservation",
            bookingRef: "N° de réservation",
            qrHint: "Veuillez présenter ce code QR à votre arrivée au restaurant",
            detailsTitle: "Détails du client et de la réservation",
            guestName: "Nom du client",
            room: "Chambre #",
            restaurant: "Restaurant",
            guests: "Personnes",
            dateTime: "Date et heure",
            hotelRes: "N° Réservation",
            arrival: "Date d'arrivée",
            departure: "Date de départ",
            allergies: "Allergies",
            noneAllergies: "Aucune",
            orderItems: "Articles commandés",
            item: "Article",
            qty: "Qté",
            price: "Prix",
            total: "Total",
            subtotal: "Sous-total",
            tax: "Taxe",
            grandTotal: "Total général",
            complimentary: "Gratuit",
            seatOnly: "Réservation de siège uniquement",
            termsTitle: "Conditions et code vestimentaire",
            thankYou: "Merci de votre visite et bon appétit !"
          },
          it: {
            title: "Conferma e ricevuta di prenotazione",
            bookingRef: "N. prenotazione",
            qrHint: "Si prega di mostrare questo codice QR all'arrivo al ristorante",
            detailsTitle: "Dettagli ospite e prenotazione",
            guestName: "Nome ospite",
            room: "Camera #",
            restaurant: "Ristorante",
            guests: "Ospiti",
            dateTime: "Data e ora",
            hotelRes: "N. Prenotazione",
            arrival: "Data di arrivo",
            departure: "Data di partenza",
            allergies: "Allergie",
            noneAllergies: "Nessuna",
            orderItems: "Articoli ordinati",
            item: "Articolo",
            qty: "Qtà",
            price: "Prezzo",
            total: "Totale",
            subtotal: "Subtotale",
            tax: "Tasse",
            grandTotal: "Totale generale",
            complimentary: "Omaggio",
            seatOnly: "Solo prenotazione tavolo",
            termsTitle: "Termini e codice di abbigliamento",
            thankYou: "Grazie per averci scelto, buon appetito!"
          },
          de: {
            title: "Reservierungsbestätigung & Beleg",
            bookingRef: "Buchungsnummer",
            qrHint: "Bitte zeigen Sie diesen QR-Code bei Ihrer Ankunft im Restaurant vor",
            detailsTitle: "Gast- & Reservierungsdetails",
            guestName: "Gastname",
            room: "Zimmer #",
            restaurant: "Restaurant",
            guests: "Gäste",
            dateTime: "Datum & Uhrzeit",
            hotelRes: "Reservierung #",
            arrival: "Ankunftsdatum",
            departure: "Abreisedatum",
            allergies: "Allergien",
            noneAllergies: "Keine",
            orderItems: "Bestellte Artikel",
            item: "Artikel",
            qty: "Menge",
            price: "Preis",
            total: "Gesamt",
            subtotal: "Zwischensumme",
            tax: "Steuer",
            grandTotal: "Gesamtsumme",
            complimentary: "Kostenlos",
            seatOnly: "Nur Tischreservierung",
            termsTitle: "Bedingungen & Kleiderordnung",
            thankYou: "Vielen Dank für Ihren Besuch!"
          },
          ru: {
            title: "Подтверждение бронирования и квитанция",
            bookingRef: "№ бронирования",
            qrHint: "Пожалуйста, предъявите этот QR-код при входе в ресторан",
            detailsTitle: "Детали гостя и бронирования",
            guestName: "Имя гостя",
            room: "Комната №",
            restaurant: "Ресторан",
            guests: "Гости",
            dateTime: "Дата и время",
            hotelRes: "Бронирование №",
            arrival: "Дата прибытия",
            departure: "Дата отъезда",
            allergies: "Аллергия",
            noneAllergies: "Нет",
            orderItems: "Заказанные блюда",
            item: "Блюдо",
            qty: "Кол-во",
            price: "Цена",
            total: "Итого",
            subtotal: "Подытог",
            tax: "Налог",
            grandTotal: "Общая сумма",
            complimentary: "Бесплатно",
            seatOnly: "Только бронирование столика",
            termsTitle: "Правила и дресс-код",
            thankYou: "Спасибо за ваш выбор! Приятного аппетита!"
          },
          ar: {
            title: "إيصال تأكيد الحجز",
            bookingRef: "رقم الحجز",
            qrHint: "يرجى إبراز رمز الاستجابة السريعة (QR) عند الوصول إلى المطعم",
            detailsTitle: "تفاصيل الضيف والحجز",
            guestName: "اسم الضيف",
            room: "رقم الغرفة",
            restaurant: "المطعم",
            guests: "عدد الأشخاص",
            dateTime: "التاريخ والوقت",
            hotelRes: "رقم الحجز الفندقي",
            arrival: "تاريخ الوصول",
            departure: "تاريخ المغادرة",
            allergies: "الحساسية",
            noneAllergies: "لا يوجد",
            orderItems: "الأصناف المطلوبة",
            item: "الصنف",
            qty: "الكمية",
            price: "السعر",
            total: "الإجمالي",
            subtotal: "المجموع الفرعي",
            tax: "الضريبة",
            grandTotal: "الإجمالي الكلي",
            complimentary: "مجاني",
            seatOnly: "حجز مقعد فقط",
            termsTitle: "الشروط وقواعد الملابس",
            thankYou: "شكراً لاختياركم لنا، نتمنى لكم تجربة ممتعة!"
          }
        };
        const t = labels[loc] || labels.en;

        const bookNumber =
          (this.orderData &&
            this.orderData.booking_details &&
            this.orderData.booking_details.book_number) ||
          this.$route.params.orderId ||
          "Receipt";

        const guestName =
          this.orderData && this.orderData.guest
            ? `${this.orderData.guest.first_name || ""} ${this.orderData.guest.last_name || ""}`.trim()
            : this.guestData.guestName || "-";
        const roomNumber =
          (this.orderData &&
            this.orderData.guest &&
            this.orderData.guest.more_data &&
            this.orderData.guest.more_data.room_number) ||
          this.guestData.guestRoom ||
          "-";
        const restaurantName =
          (this.orderData &&
            this.orderData.restaurant &&
            this.orderData.restaurant.title) ||
          "-";
        const companions =
          (this.guestData && this.guestData.companions) || "1";
        const bookingDate =
          (this.orderData &&
            this.orderData.booking_details &&
            this.orderData.booking_details.date) ||
          "-";
        const bookingTime =
          (this.orderData &&
            this.orderData.booking_details &&
            this.orderData.booking_details.time &&
            this.orderData.booking_details.time.time) ||
          "";
        const dateTimeStr = `${this.orderDay ? this.orderDay + ", " : ""}${bookingDate}${bookingTime ? " (" + bookingTime + ")" : ""}`;
        const reservationNo =
          (this.orderData &&
            this.orderData.guest &&
            this.orderData.guest.more_data &&
            this.orderData.guest.more_data.reservation) ||
          this.guestData.guestReservation ||
          "-";
        const arrivalDate = (this.guestData && this.guestData.guestArrivalData) || "-";
        const departureDate = (this.guestData && this.guestData.guestDepartureDate) || "-";
        const allergyText = this.bookingAllergies || t.noneAllergies;

        const items =
          this.orderData && Array.isArray(this.orderData.items)
            ? this.orderData.items
            : [];

        const defaultMultilingualTerms = [
          "• In all restaurants dress code is “smart casual elegant”. Dear gentlemen please avoid short pants in general and please wear trousers.",
          "• Минимальный дресс код: повседневная одежда и обувь, приветствуется элегантный повседневный стиль в одежде (для мужчин длинные брюки вечером).",
          "• يرجى ارتداء الملابس المناسبة داخل جميع المطاعم وعدم ارتداء ملابس البحر او حافى القدمين لا يسمح بارتداء الشورت او الشبشب او الترينجات الرياضيه .",
          "• Es gilt in allen Restaurants die Kleiderordnung “schick, lässig, elegant”. Der Mann sollte eine lange Hose tragen.",
          "• Dans tous les restaurants, le code vestimentaire est décontracté et élégant.",
          "• Vi chiediamo di indossare in tutti i ristoranti un abbigliamento appropriato, “smart casual elegant”."
        ].join("\n");

        const rawTerms =
          (this.orderData &&
            this.orderData.restaurant &&
            this.orderData.restaurant.confirmation_terms) ||
          defaultMultilingualTerms;

        // Measure terms lines on a scratch canvas first
        const measureCanvas = document.createElement("canvas");
        const mCtx = measureCanvas.getContext("2d");
        mCtx.font = "18px Arial, sans-serif";
        const wrappedTerms = this.wrapCanvasText(mCtx, rawTerms, 1020);

        const W = 1200;
        const itemsHeight = items.length > 0 ? 110 + items.length * 48 + 150 : 95;
        const termsHeight = Math.max(110, 65 + wrappedTerms.length * 28);
        const H = Math.max(1620, 960 + itemsHeight + termsHeight + 120);

        const canvas = document.createElement("canvas");
        canvas.width = W;
        canvas.height = H;
        const ctx = canvas.getContext("2d");

        // 1. White Page Background
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, W, H);

        // 2. Dark Header Banner for Logo
        const padX = 60;
        const contentW = W - padX * 2;
        let curY = 45;

        ctx.fillStyle = "#1a1a1a";
        ctx.fillRect(padX, curY, contentW, 155);
        ctx.fillStyle = "#d7b578";
        ctx.fillRect(padX, curY + 150, contentW, 5);

        const logoImg = await this.loadLogoForCanvas(this.hotelLogo);
        if (logoImg) {
          try {
            const maxLW = 360;
            const maxLH = 115;
            const iw = logoImg.naturalWidth || logoImg.width || 300;
            const ih = logoImg.naturalHeight || logoImg.height || 120;
            const scale = Math.min(maxLW / iw, maxLH / ih);
            const dw = iw * scale;
            const dh = ih * scale;
            ctx.drawImage(logoImg, (W - dw) / 2, curY + (150 - dh) / 2, dw, dh);
          } catch (e) {
            ctx.fillStyle = "#ffffff";
            ctx.font = "bold 36px Georgia, serif";
            ctx.textAlign = "center";
            ctx.fillText("SRNTY SAHL HASHEESH", W / 2, curY + 85);
          }
        } else {
          ctx.fillStyle = "#ffffff";
          ctx.font = "bold 36px Georgia, serif";
          ctx.textAlign = "center";
          ctx.fillText("SRNTY SAHL HASHEESH", W / 2, curY + 85);
        }

        curY += 195;

        // 3. Receipt Title & Booking Number
        ctx.fillStyle = "#1a1a1a";
        ctx.font = "bold 30px Arial, sans-serif";
        ctx.textAlign = "center";
        ctx.fillText(t.title, W / 2, curY);

        curY += 36;
        ctx.fillStyle = "#555555";
        ctx.font = "bold 22px Arial, sans-serif";
        ctx.fillText(`${t.bookingRef}: #${bookNumber}`, W / 2, curY);

        curY += 25;

        // 4. QR Code Section
        const qrCanvas = document.querySelector(".bdt-qrcode canvas");
        if (qrCanvas) {
          const qrBoxW = 560;
          const qrBoxH = 260;
          const qrBoxX = (W - qrBoxW) / 2;
          ctx.fillStyle = "#fafafa";
          ctx.fillRect(qrBoxX, curY, qrBoxW, qrBoxH);
          ctx.strokeStyle = "#dcdcdc";
          ctx.lineWidth = 2;
          ctx.strokeRect(qrBoxX, curY, qrBoxW, qrBoxH);

          const qrSize = 190;
          ctx.drawImage(qrCanvas, (W - qrSize) / 2, curY + 18, qrSize, qrSize);

          ctx.fillStyle = "#555555";
          ctx.font = "17px Arial, sans-serif";
          ctx.textAlign = "center";
          ctx.fillText(t.qrHint, W / 2, curY + qrBoxH - 18);

          curY += qrBoxH + 35;
        } else {
          curY += 20;
        }

        // 5. Guest & Reservation Details Table
        ctx.textAlign = "left";
        ctx.fillStyle = "#1a1a1a";
        ctx.font = "bold 22px Arial, sans-serif";
        ctx.fillText(t.detailsTitle, padX, curY);
        curY += 12;
        ctx.fillStyle = "#d7b578";
        ctx.fillRect(padX, curY, 80, 4);
        curY += 16;

        const rows = [
          [t.guestName, guestName, t.room, String(roomNumber)],
          [t.restaurant, restaurantName, t.guests, String(companions)],
          [t.dateTime, dateTimeStr, t.hotelRes, String(reservationNo)],
          [t.arrival, String(arrivalDate), t.departure, String(departureDate)]
        ];

        const rowH = 54;
        const colWidths = [220, 320, 220, 320];

        rows.forEach((r) => {
          let colX = padX;
          for (let c = 0; c < 4; c++) {
            const cw = colWidths[c];
            ctx.fillStyle = c % 2 === 0 ? "#f7f8fa" : "#ffffff";
            ctx.fillRect(colX, curY, cw, rowH);
            ctx.strokeStyle = "#e2e5e9";
            ctx.lineWidth = 1.5;
            ctx.strokeRect(colX, curY, cw, rowH);

            ctx.fillStyle = c % 2 === 0 ? "#495057" : "#111111";
            ctx.font = c % 2 === 0 ? "bold 18px Arial, sans-serif" : "19px Arial, sans-serif";
            ctx.textAlign = "left";
            const cellText = String(r[c] || "-");
            ctx.fillText(cellText, colX + 14, curY + 34, cw - 24);
            colX += cw;
          }
          curY += rowH;
        });

        // Full-width row for Allergies & Booking Type
        const halfW = 320;
        ctx.fillStyle = "#f7f8fa";
        ctx.fillRect(padX, curY, 220, rowH);
        ctx.strokeStyle = "#e2e5e9";
        ctx.lineWidth = 1.5;
        ctx.strokeRect(padX, curY, 220, rowH);
        ctx.fillStyle = "#495057";
        ctx.font = "bold 18px Arial, sans-serif";
        ctx.textAlign = "left";
        ctx.fillText(t.allergies, padX + 14, curY + 34, 196);

        ctx.fillStyle = this.bookingAllergies ? "#fff5f5" : "#ffffff";
        ctx.fillRect(padX + 220, curY, halfW, rowH);
        ctx.strokeStyle = "#e2e5e9";
        ctx.strokeRect(padX + 220, curY, halfW, rowH);
        ctx.fillStyle = this.bookingAllergies ? "#dc3545" : "#111111";
        ctx.font = this.bookingAllergies ? "bold 19px Arial, sans-serif" : "19px Arial, sans-serif";
        ctx.fillText(String(allergyText), padX + 234, curY + 34, halfW - 24);

        ctx.fillStyle = "#f7f8fa";
        ctx.fillRect(padX + 540, curY, 220, rowH);
        ctx.strokeStyle = "#e2e5e9";
        ctx.strokeRect(padX + 540, curY, 220, rowH);
        ctx.fillStyle = "#495057";
        ctx.font = "bold 18px Arial, sans-serif";
        ctx.fillText(this.bookingTypeTitleLabel, padX + 554, curY + 34, 196);

        ctx.fillStyle = this.isPaidBooking ? "#fff5f5" : "#f0fff4";
        ctx.fillRect(padX + 760, curY, halfW, rowH);
        ctx.strokeStyle = "#e2e5e9";
        ctx.strokeRect(padX + 760, curY, halfW, rowH);
        ctx.fillStyle = this.isPaidBooking ? "#dc3545" : "#28a745";
        ctx.font = "bold 19px Arial, sans-serif";
        ctx.fillText(String(this.bookingTypeBadgeLabel), padX + 774, curY + 34, halfW - 24);
        curY += rowH;

        curY += 35;

        // 6. Order Items or Seat Only Badge
        if (items.length > 0) {
          ctx.textAlign = "left";
          ctx.fillStyle = "#1a1a1a";
          ctx.font = "bold 22px Arial, sans-serif";
          ctx.fillText(t.orderItems, padX, curY);
          curY += 18;

          const iCols = [540, 140, 200, 200];
          const headers = [t.item, t.qty, t.price, t.total];
          let hx = padX;
          for (let i = 0; i < 4; i++) {
            ctx.fillStyle = "#212529";
            ctx.fillRect(hx, curY, iCols[i], 48);
            ctx.fillStyle = "#ffffff";
            ctx.font = "bold 18px Arial, sans-serif";
            ctx.textAlign = i === 0 ? "left" : "center";
            ctx.fillText(
              headers[i],
              i === 0 ? hx + 16 : hx + iCols[i] / 2,
              curY + 30
            );
            hx += iCols[i];
          }
          curY += 48;

          items.forEach((item, idx) => {
            let ix = padX;
            const bg = idx % 2 === 0 ? "#ffffff" : "#f9fafb";
            const lineTotal = (Number(item.price) || 0) * (Number(item.quantity) || 1);
            const vals = [
              String(item.name || ""),
              String(item.quantity || 1),
              `${item.price || 0} ${this.currency}`,
              `${lineTotal} ${this.currency}`
            ];
            for (let i = 0; i < 4; i++) {
              ctx.fillStyle = bg;
              ctx.fillRect(ix, curY, iCols[i], 46);
              ctx.strokeStyle = "#e5e7eb";
              ctx.lineWidth = 1;
              ctx.strokeRect(ix, curY, iCols[i], 46);

              ctx.fillStyle = "#222222";
              ctx.font = "18px Arial, sans-serif";
              ctx.textAlign = i === 0 ? "left" : "center";
              ctx.fillText(
                vals[i],
                i === 0 ? ix + 16 : ix + iCols[i] / 2,
                curY + 29,
                iCols[i] - 20
              );
              ix += iCols[i];
            }
            curY += 46;
          });

          // Summary rows
          const summaryBadge = this.isPaidBooking ? this.bookingTypeBadgeLabel : t.complimentary;
          const summaryRows = [
            [t.subtotal, `${this.orderData.subtotal || 0} ${this.currency}`],
            [t.tax, `${this.orderData.tax || 0}%`],
            [t.grandTotal, `${this.orderData.total_price || 0} ${this.currency} (${summaryBadge})`]
          ];
          summaryRows.forEach((sr, sIdx) => {
            const isLast = sIdx === summaryRows.length - 1;
            ctx.fillStyle = isLast ? "#f1f3f5" : "#ffffff";
            ctx.fillRect(padX, curY, contentW, 44);
            ctx.strokeStyle = "#dee2e6";
            ctx.strokeRect(padX, curY, contentW, 44);

            ctx.fillStyle = "#111111";
            ctx.font = isLast ? "bold 20px Arial, sans-serif" : "bold 18px Arial, sans-serif";
            ctx.textAlign = "right";
            ctx.fillText(sr[0] + ":", padX + 680, curY + 29);
            ctx.textAlign = "center";
            ctx.fillText(sr[1], padX + 880, curY + 29);
            curY += 44;
          });

          curY += 30;
        } else {
          ctx.fillStyle = "#f8f9fa";
          ctx.fillRect(padX, curY, contentW, 64);
          ctx.strokeStyle = "#d7b578";
          ctx.lineWidth = 2;
          ctx.strokeRect(padX, curY, contentW, 64);

          ctx.fillStyle = "#1a1a1a";
          ctx.font = "bold 22px Arial, sans-serif";
          ctx.textAlign = "center";
          ctx.fillText(t.seatOnly, W / 2, curY + 40);
          curY += 90;
        }

        // 7. Confirmation Terms / Dress Code Box
        const boxH = 55 + wrappedTerms.length * 28;
        ctx.fillStyle = "#fffdf5";
        ctx.fillRect(padX, curY, contentW, boxH);
        ctx.strokeStyle = "#f0e6c8";
        ctx.lineWidth = 1.5;
        ctx.strokeRect(padX, curY, contentW, boxH);
        ctx.fillStyle = "#d7b578";
        ctx.fillRect(padX, curY, 8, boxH);

        ctx.fillStyle = "#1a1a1a";
        ctx.font = "bold 19px Arial, sans-serif";
        ctx.textAlign = "left";
        ctx.fillText(t.termsTitle + ":", padX + 24, curY + 32);

        ctx.fillStyle = "#333333";
        ctx.font = "18px Arial, sans-serif";
        let ty = curY + 62;
        wrappedTerms.forEach((line) => {
          ctx.fillText(line, padX + 24, ty, contentW - 44);
          ty += 28;
        });

        curY += boxH + 40;

        // 8. Footer Thank You
        ctx.strokeStyle = "#e5e7eb";
        ctx.lineWidth = 1.5;
        ctx.beginPath();
        ctx.moveTo(padX, curY);
        ctx.lineTo(W - padX, curY);
        ctx.stroke();

        ctx.fillStyle = "#222222";
        ctx.font = "bold 22px Arial, sans-serif";
        ctx.textAlign = "center";
        ctx.fillText(t.thankYou, W / 2, curY + 40);

        // 9. Export Canvas to A4 PDF via jsPDF
        const imgData = canvas.toDataURL("image/jpeg", 0.95);
        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4"
        });

        const pageW = pdf.internal.pageSize.getWidth();
        const pageH = pdf.internal.pageSize.getHeight();
        const margin = 8;
        const availW = pageW - margin * 2;
        const availH = pageH - margin * 2;

        let renderW = availW;
        let renderH = (canvas.height * renderW) / canvas.width;
        if (renderH > availH) {
          renderH = availH;
          renderW = (canvas.width * renderH) / canvas.height;
        }
        const offsetX = (pageW - renderW) / 2;

        pdf.addImage(imgData, "JPEG", offsetX, margin, renderW, renderH);
        pdf.save(`Receipt-Booking-${bookNumber}.pdf`);
      } catch (err) {
        console.error("Failed to generate PDF receipt:", err);
        this.thirmalPrint();
      } finally {
        this.isGeneratingPdf = false;
      }
    },
    thirmalPrint(){
		const printWindow = window.open('', '', 'height=600,width=400');
		 const content=`<html>
        <head>
          <title>Booking Details</title>
          <style>
            body {
			text-align:center;
              font-family: Arial, sans-serif;
              font-size: 24px;
              margin: 0;
              padding: 0;
              width: 80mm; 
            }
            table {
              width: 100%;
              border-collapse: collapse;
            }
            td, th {
              border-bottom: 1px solid #000;
              padding: 4px;
            }
            th {
              text-align: left;
            }
            .header, .footer {
              text-align: center;
              margin-bottom: 10px;
            }
          </style>
        </head>
        <body>`+document.getElementById("thermalPrintContent").innerHTML+"</body></html>";
		// Write the content to the new window and print
      printWindow.document.open();
      printWindow.document.write(content);
      printWindow.document.close();
      printWindow.focus(); // Required for IE
      printWindow.print();
	    printWindow.close();
	},
    setLang() {
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "api/frontend-keywords?api_key=" +
            process.env.VUE_APP_API_KEY +
            "&lang=" +
            //this.$i18n.locale
            localStorage.getItem('localization')
        )
        .then(
          (res) => {
            console.log(res)
            this.lang = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },getGuestInfo(){
		this.axios
      .get(
        process.env.VUE_APP_API_BASE_URL +
          "api/user-profile?api_key=" +
          process.env.VUE_APP_API_KEY +
          "&lang=" +
          process.env.VUE_APP_LANG +
          "&api_token=" +
                 localStorage.getItem("token") +
          "&hotel_id=1&restaurant_id=1"
      )
      .then((res) => {
		  console.log(" ----------- Guest Info ---------");
		  console.log(res);
        this.guestData.guestName = res.data.data.first_name + ' ' + res.data.data.last_name
        this.guestData.guestRoom = res.data.data.more_data.room_number
        this.guestData.guestReservation = res.data.data.more_data.reservation
        this.guestData.guestArrivalData = res.data.data.more_data.checkin_date
        this.guestData.guestDepartureDate = res.data.data.more_data.checkout_date
		this.guestData.companions = res.data.data.more_data.companions
        this.isLoading = false;
		this.getOrderData()


 
      })
      .catch((error) => console.log(error));
	},
     getOrderData() {
      this.axios
        .get(
          process.env.VUE_APP_API_BASE_URL +
            "api/order-data-with-order-id?api_key=" +
            process.env.VUE_APP_API_KEY +
            "&lang=" +
            localStorage.getItem('localization') +
            "&api_token=" +
            localStorage.getItem("token") +
            // "8KxcnRyDoGwOBhjbjhrrx3vLuhUAoY3h28RO6indKBiBdKuL2IfZJ8bbrskX"+
            "&order_id=" +
            this.$route.params.orderId
        )
        .then((res) => {
          if (res.data.data) {
            this.orderData =res.data.data
            const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

            const d = new Date(this.orderData.booking_details.date);
            let day = weekday[d.getDay()];
             
           this.orderDay =day
          } else {
            console.log("n");
          }
        })
        .catch((error) => console.log(error));
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style>
  html.is-rtl * {
    direction: rtl;
}
</style>
<!-- eslint-enable -->
